<ion-item
  *ngIf="!horizontal"
  class="status-color"
  [class.my-status]="isMyStatus"
  [class.allowed]="isAllowed"
  [class.bold]="isMyStatus && useStatusColor"
  [style.color]="useStatusColor ? statusColor : ''"
  (click)="onStatusClicked($event)"
>
  <ion-label class="ion-text-center">
    <h2 [style.font-size]="statusNameFontSize">
      {{ statusName | translate }}
    </h2>
    <h2 [style.font-size]="statusTimeFontSize">{{ statusTime }}</h2>
  </ion-label>
</ion-item>

<div
  *ngIf="horizontal"
  class="status-item-horizontal status-color"
  [class.my-status]="isMyStatus"
  [class.allowed]="isAllowed"
  [class.bold]="isMyStatus && useStatusColor"
  [style.color]="useStatusColor ? statusColor : ''"
  [class.horizontal]="horizontal"
  (click)="onStatusClicked($event)"
>
  <div class="status-name small-items" [style.font-size]="statusNameFontSize">
    {{ statusName | translate }}
  </div>
  <app-icon *ngIf="showIcon" [icon]="statusIcon" maxWidth="48px"></app-icon>
  <div class="status-time small-items" [style.font-size]="statusTimeFontSize">
    {{ statusTime }}
  </div>
</div>
